import { render } from "./WCDeleteAccountModal.vue?vue&type=template&id=76bd5e22&scoped=true&ts=true"
import script from "./WCDeleteAccountModal.vue?vue&type=script&lang=ts"
export * from "./WCDeleteAccountModal.vue?vue&type=script&lang=ts"

import "./WCDeleteAccountModal.vue?vue&type=style&index=0&id=76bd5e22&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76bd5e22"]])

export default __exports__